Namespace 'Models'

class Models.SocialUser extends Backbone.Model
  defaults:
    brand_followers: []
    brand_following: []
    data: {}
    social_network_id: '00000'
    source: 'facebook'
    values: {}

  initialize: ->
    @set('id', "#{@get('source')}-#{@get('social_network_id')}")

  name: =>
    @get('values').name

  username: =>
    @get('values').username

  avatar: =>
    @get('values').avatar

class Models.SocialUserCollection extends Backbone.Collection
  model: Models.SocialUser
